import React from 'react'
import Content from '../../../Components/Dashboard/Content/Content'
import CoinDCXDashboard from '../../../Components/Dashboard/Content/CoinDCXDashboard'

export default function CoinDCX() {
    return (
        <Content>
            <CoinDCXDashboard />
        </Content>
    )
}
